// Definición de defaults

export const defaultTipoOficio: TipoOficioProps = {
    idTipoOficio:       0,
    descripcion:        '',
    activo:             false
};

// Creación de interfaces

export interface TipoOficioProps   {
    idTipoOficio:       number;
    descripcion:        string;
    activo:             boolean;
}